import React, { useContext, useEffect } from 'react';
import { Context } from "../contexts/AppContext";

function ImageController() {

    const { value } = useContext(Context);  
    const [appState, setAppState] = value;  

     useEffect(() => {
        const handleMessage = (event) => {
         
          if (typeof event.data === "object" && event.data !== null) {
            setAppState((prevState) => ({
              ...prevState,
              ...event.data,
            }));
          }
        };
    
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
      }, [appState, setAppState]);
   
  return (
    <div
    id="img-bg"
    className="absolute w-full h-full"
  >
    <img
      key={"thumb"}
      className="w-full h-full object-cover object-center"
      src={
        appState.currentGalleryData?.backgroundMedia?.imgUrl
          ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.currentGalleryData?.backgroundMedia?.imgUrl}`
          : null
      }
      alt="Background"
    />
  </div>
  
  );
}

export default ImageController;
